import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import link from './link.js';
var schema = defineObject('columnInfoGroupSectionCell', {
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    subtitle: {
        title: 'Subtitle',
        type: 'string'
    },
    action: {
        title: 'Action',
        type: 'link'
    }
}, [
    link.schema.link
]);
var validator = z.object({
    _type: z.literal('columnInfoGroupSectionCell'),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    action: link.validator.optional()
});
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=columnInfoGroupSectionCell.js.map